import { ConfiguredRetryStrategy } from '@smithy/util-retry';
const SECOND = 1000;
const MAXIMUM_RETRY_DELAY = 20 * SECOND;
export function delayFactory(initialDelay) {
    return (attempt) => 2 ** attempt * initialDelay;
}
export class RetryAllStrategy extends ConfiguredRetryStrategy {
    totalAttempts;
    calculateDalay;
    constructor(totalAttempts, initialDelay) {
        super(totalAttempts, delayFactory(initialDelay));
        this.totalAttempts = totalAttempts;
        this.calculateDalay = delayFactory(initialDelay);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        try {
            return await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        }
        catch (error) {
            const attempt = tokenToRenew.getRetryCount() + 1;
            if (attempt < this.totalAttempts) {
                return RetryAllStrategy.createToken(attempt, this.calculateDalay(attempt));
            }
            throw error;
        }
    }
    static createToken(retryCount, retryDelay) {
        const getRetryCount = () => retryCount;
        const getRetryDelay = () => Math.min(MAXIMUM_RETRY_DELAY, retryDelay);
        const getRetryCost = () => 0;
        return {
            getRetryCount,
            getRetryDelay,
            getRetryCost,
        };
    }
}
